<template>
    <div>
        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon>more_horiz</v-icon>
                </v-btn>
            </template>
            <v-list flat>
                <v-list-item-group>

                    <v-list-item :to="{ name: 'Products.Edit', params: {id: item.id}}">
                        <v-list-item-title>{{ $t('edit') }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item :to="{ name: 'Products.Copy', params: {id: item.id}}">
                        <v-list-item-title>{{ $t('copy') }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item :to="{ name: 'Orders', query: {product_id: [item.id]}}">
                        <v-list-item-title>{{ $t('productOrders')}}</v-list-item-title>
                    </v-list-item>

                    <v-list-item :href="productUrl">
                        <v-list-item-title>{{ $t('toProduct') }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="showDeleteSnack">
                        <v-list-item-title>{{ $t('remove') }}</v-list-item-title>
                    </v-list-item>

                </v-list-item-group>
            </v-list>
        </v-menu>
        <v-snackbar
            v-model="snackOpen"
            :color="snackColor"
            dark
            top
        >
            <span class="body-2 pr-4">{{ snackText }}</span>
            <div>
                <v-btn
                    v-if="snackDelete"
                    class="text--main-yellow"
                    @click="remove"
                    text
                >
                    {{ $t('yes') }}
                </v-btn>
                <v-btn text icon @click="closeSnack">
                    <v-icon color="grey">close</v-icon>
                </v-btn>
            </div>
        </v-snackbar>
        <load-overlay :overlay="overlay"></load-overlay>
    </div>
</template>

<script>
import LoadOverlay from "../../overlays/LoadOverlay";
import { MixinAppSnack } from "../../../mixins";
import { ProductsService } from "../../../services";
export default {
    name: "TableActions",
    components: { LoadOverlay },
    mixins: [ MixinAppSnack ],
    props: [ 'item' ],
    data() {
        return {
            overlay: false,
            actions: [
                { title: this.$t('edit'), route: '#' },
                { title: this.$t('copy'), route: '#'},
                { title: this.$t('productOrders'), route: '#' },
            ],
        }
    },
    computed: {
        productUrl() {
            return `${this.$store.getters.frontUrl}/products/${this.item.parentSysName}/${this.item.catSysName}/${this.item.prodSysName}-${this.item.id}`;
        }
    },
    methods: {
        cLog() {
            console.log(this.item);
        },
        showDeleteSnack() {
            this.resetSnack();
            this.setSnackText(this.$t('delete'))
            this.setDeleteSnack();
            this.openSnack();
        },
        remove() {
            this.resetSnack();
            this.overlay = true;
            ProductsService.delete(this.item.id)
                .then(() => {
                    this.overlay = false;
                    this.setSuccessSnack();
                    this.setSnackText(this.$t('successfulDeleted'));
                    this.openSnack();
                    this.$emit('set-items');
                })
                .catch(err => {
                    const errData = err.response.data;
                    if(errData.error && errData.error.includes('Sending message error')) {
                        this.setSnackText(`${this.$t('successfulDeleted')}. ${this.$t('sendMessageError')}`);
                        this.setWarningSnack();
                        setTimeout(() => {
                            this.$emit('set-items');
                        }, 2000);
                    } else {
                        this.setSnackText(this.$t('changesSavedError'));
                        this.setErrorSnack();
                    }
                    this.openSnack();
                    this.overlay = false;
                    console.log(err);
                });
        }
    }
}
</script>

<style scoped>

</style>
